import {SocialMediaIconModel} from '@/Pages/Admin/Modules/Models/Master/SocialMediaIconModel';
export class SocialMediaModel {
    public id: number;
    public account_id: number;
    public social_media_id: number;
    public link: string;
    public created_at: string;
    public updated_at: string;
    public social_media: SocialMediaIconModel = new SocialMediaIconModel({});


    constructor(obj: any) {
        this.id = obj.id ? obj.id : 0;
        this.account_id = obj.account_id ? obj.account_id : 0;
        this.social_media_id = obj.social_media_id ? obj.social_media_id : 0;
        this.link = obj.link ? obj.link : '';
        this.social_media = obj.social_media ? obj.social_media : new SocialMediaIconModel({});
        this.created_at = obj.created_at ? obj.created_at : '';
        this.updated_at = obj.updated_at ? obj.updated_at : '';
    }
}
